import { Observable } from 'rxjs';
import { AppFilter } from './../../../models/app-filter.model';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AbLogIntegracao } from 'app/abstract/full-pages/log-integracao/log-integracao.abstract';

@Injectable({ providedIn: 'root' })
export class LogIntegracaoService extends AbLogIntegracao {

  constructor(http: HttpClient) {
    super(http);
  }

  public sincronizar() {
    return this.get(`sincronizacao`);
  }

  public deleteOlderLogsByTenant() {
    return this.get(`sincronizacao/delete_older_logs`);
  }

  public getAllLogs(filter: AppFilter): Observable<any> {
    return this.get(`sincronizacao/logs/filter/${filter.encode()}`);
  }

  public getStatusAsPromise() {
    return this.get('sincronizacao/status').toPromise();
  }

}
